import { render, staticRenderFns } from "./AddStakingBuyModal.vue?vue&type=template&id=5abfb55a&"
import script from "./AddStakingBuyModal.vue?vue&type=script&lang=js&"
export * from "./AddStakingBuyModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports